import URL from '@/Utilities/URL';
class Helper {
    static url() {
        return URL;
    }
    static get storeManager() {
        return window.storeManager;
    }
    static getExtrapolationDatesForMonth(year, month) {
        // Use the 10th of the month in format to avoid issues with timezones
        const date = moment(year + '-' + month + '-10', 'YYYY-MM-DD').utc().startOf('month').startOf('week');
        const endOfMonth = moment(year + '-' + month + '-10', 'YYYY-MM-DD').utc().endOf('month');
        const dates = [];
        do {
            if (year === 2021 && month === 11 && date.isSame(moment.utc('2021-11-29'), 'day')) {
                dates.push(date.clone());
                continue;
            }
            if (date.month() + 1 !== month) {
                continue;
            }
            if (date.date() < 10 || date.date() >= (endOfMonth.date() - 2)) {
                continue;
            }
            dates.push(date.clone());
        } while (date.add(1, 'week').month() + 1 === month);
        return dates;
    }
    static getExtrapolationCountForMonth(year, month) {
        return Helper.getExtrapolationDatesForMonth(year, month).length;
    }
}
export default Helper;
